
import Header from '@/components/General/Header.vue';
import { MUTATIONS } from '@/constants/mutationNames';
import { Component, Vue } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';
import { FLOW_ADMIN } from '@/router';
import { GETTERS } from '@/constants/getterNames';

@Component({
  components: {
    Header,
  },
})
export default class AdminView extends Vue {

  public routes: RouteConfig[] = FLOW_ADMIN;

  get error() {
    return this.$store.getters[GETTERS.GET_ERROR];
  }

  public dismissError() {
    this.$store.commit(MUTATIONS.SET_ERROR, {});
  }
}
